import {
  SHOW_PREFERENCES,
  EDIT_PREFERENCES,
  HIDE_PREFERENCES,
  SAVE_PREFERENCES
} from './types';


export const showPreferences = () => ({
  type: SHOW_PREFERENCES
});

export const hidePreferences = () => ({
  type: HIDE_PREFERENCES
});

export const savePreferences = (data) => ({
  type: SAVE_PREFERENCES,
  data
});

export const editPreferences = (data) => ({
  type: EDIT_PREFERENCES,
  data
});



